var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import { textPropsByEngine } from '@nivo/core';
import { computeRadialLabels } from './compute';

export var drawSliceLabels = function drawSliceLabels(ctx, arcs, _ref) {
    var arcGenerator = _ref.arcGenerator,
        getLabel = _ref.getLabel,
        skipAngle = _ref.skipAngle,
        getTextColor = _ref.getTextColor,
        theme = _ref.theme;

    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = theme.labels.text.fontSize + 'px ' + theme.labels.text.fontFamily;

    arcs.filter(function (arc) {
        return skipAngle === 0 || arc.angleDeg > skipAngle;
    }).forEach(function (arc) {
        var _arcGenerator$centroi = arcGenerator.centroid(arc),
            centroidX = _arcGenerator$centroi[0],
            centroidY = _arcGenerator$centroi[1];

        var sliceLabel = getLabel(arc.data);
        var textColor = getTextColor(arc, theme);

        ctx.save();
        ctx.translate(centroidX, centroidY);
        ctx.fillStyle = textColor;
        ctx.fillText(sliceLabel, 0, 0);
        ctx.restore();
    });
};

export var drawRadialLabels = function drawRadialLabels(ctx, arcs, _ref2) {
    var radius = _ref2.radius,
        getLabel = _ref2.getLabel,
        skipAngle = _ref2.skipAngle,
        linkOffset = _ref2.linkOffset,
        linkDiagonalLength = _ref2.linkDiagonalLength,
        linkHorizontalLength = _ref2.linkHorizontalLength,
        linkStrokeWidth = _ref2.linkStrokeWidth,
        textXOffset = _ref2.textXOffset,
        getTextColor = _ref2.getTextColor,
        getLinkColor = _ref2.getLinkColor,
        theme = _ref2.theme;

    var radialLabels = computeRadialLabels(arcs, {
        getLabel: getLabel,
        radius: radius,
        skipAngle: skipAngle,
        linkOffset: linkOffset,
        linkDiagonalLength: linkDiagonalLength,
        linkHorizontalLength: linkHorizontalLength,
        textXOffset: textXOffset
    });

    ctx.textBaseline = 'middle';
    ctx.font = theme.labels.text.fontSize + 'px ' + theme.labels.text.fontFamily;

    radialLabels.forEach(function (label) {
        var dataWithColor = _extends({}, label.arc.data, {
            color: label.arc.color
        });

        ctx.save();
        ctx.translate(label.position.x, label.position.y);
        ctx.fillStyle = getTextColor(dataWithColor, theme);
        ctx.textAlign = textPropsByEngine.canvas.align[label.align];
        ctx.fillText(label.text, 0, 0);
        ctx.restore();

        ctx.beginPath();
        ctx.strokeStyle = getLinkColor(dataWithColor, theme);
        ctx.lineWidth = linkStrokeWidth;
        label.line.forEach(function (point, index) {
            if (index === 0) ctx.moveTo(point.x, point.y);else ctx.lineTo(point.x, point.y);
        });
        if (linkStrokeWidth > 0) ctx.stroke();
    });
};